import { render, staticRenderFns } from "./ServiceTarget.vue?vue&type=template&id=5095a854&"
import script from "./ServiceTarget.vue?vue&type=script&lang=js&"
export * from "./ServiceTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports